/** The host a miniapp is running inside, reported by the SDK's host info `platform` field. */
export const HOST_PLATFORMS = {
  MOBILE: 'mobile',
  WEB: 'web',
  TENANT_PORTAL: 'tenant-portal',
} as const;

export type HostPlatform = (typeof HOST_PLATFORMS)[keyof typeof HOST_PLATFORMS];

/** Desktop hosts (web + tenant portal) get in-app chrome; mobile uses the native shell header. */
export const isDesktopHost = (platform: HostPlatform | undefined): boolean =>
  platform === HOST_PLATFORMS.WEB || platform === HOST_PLATFORMS.TENANT_PORTAL;

/**
 * The `value` a webview command carries when it is asking for a MODULE rather than a record.
 *
 * A host that shows records beside the list — the tenant portal's full-page surface — needs to tell
 * the two apart, because a module is a page: it wants its own route, with the room and the url that
 * deserves, not a detail pane beside the list that launched it.
 *
 * Said explicitly rather than inferred. The portal used to read "names a utility button" as "is a
 * module", which was only ever a proxy: a visit names one for an unrelated reason and was dragged
 * off the page by it, and a work order names none, so "Submit a request" was dragged into the pane.
 * Every host that does not know this token ignores it — `value` is unread for a webview command on
 * both native shells — so it costs nothing where it means nothing.
 */
export const MODULE_COMMAND_VALUE = 'MODULE';
